import { render, staticRenderFns } from "./Vr360Index.vue?vue&type=template&id=8751b04a&scoped=true"
import script from "./Vr360Index.vue?vue&type=script&lang=js"
export * from "./Vr360Index.vue?vue&type=script&lang=js"
import style0 from "./Vr360Index.vue?vue&type=style&index=0&id=8751b04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8751b04a",
  null
  
)

export default component.exports